import {
  IconWarningCircle24Line as ExclamationCircleIcon,
  IconInfoCircle24Line as InformationCircleIcon,
  IconHelpCircle24Line as QuestionMarkCircleIcon,
} from "@wayflyer/flyui-icons/24/line";
import type { BaseModalProps, ButtonGroupProps, FlyIcon } from "@wayflyer/flyui";
import {
  BaseModal,
  DialogBody,
  DialogFooter,
  Flex,
  Text,
  TextContainer,
  TextHeading,
  Icon as IconWrapper,
} from "@wayflyer/flyui";
import { useIntl } from "react-intl";

type Variant = "question" | "warning" | "info";

export interface ConfirmModalProps
  extends Pick<BaseModalProps, "children" | "isOpen">, Pick<ButtonGroupProps, "primaryAction" | "tertiaryAction"> {
  title: string;
  variant?: Variant;
}

const iconMap: Record<Variant, { icon: FlyIcon; props }> = {
  question: { icon: QuestionMarkCircleIcon, props: {} },
  warning: { icon: ExclamationCircleIcon, props: { color: "warning" } },
  info: { icon: InformationCircleIcon, props: { color: "info" } },
};

export const ConfirmModal = ({
  variant = "question",
  title,
  children,
  isOpen = false,
  primaryAction,
  tertiaryAction,
}: ConfirmModalProps) => {
  const intl = useIntl();
  const Icon = iconMap[variant].icon;
  const iconProps = iconMap[variant].props;

  return (
    <BaseModal ariaLabel={title} isOpen={isOpen}>
      <DialogBody $hasFooter>
        <Flex gap="3" wrap="nowrap" padding={["3", "0", "0"]}>
          <IconWrapper {...iconProps}>
            <Icon />
          </IconWrapper>
          <TextContainer spacing="2">
            <TextHeading>{title}</TextHeading>
            <Text>{children}</Text>
          </TextContainer>
        </Flex>
      </DialogBody>
      <DialogFooter
        primaryAction={{ content: "Yes", ...primaryAction }}
        tertiaryAction={{
          content: intl.formatMessage({ id: "shared-ui: Cancel", defaultMessage: "Cancel" }),
          ...tertiaryAction,
        }}
        tertiaryActionVariant="Tertiary"
      />
    </BaseModal>
  );
};
